import * as React from 'react';
import { Button, Tooltip, Box } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import s from './ProductButton.scss';
import { DowngradeWarning } from './DowngradeWarning';

type ProductButtonSize = 'small' | 'medium';
interface ProductButtonProps {
  text: string;
  onClick: () => void;
  size?: ProductButtonSize;
  fullColor?: boolean;
  disabled?: boolean;
  dataHook?: string;
  fullWidth?: boolean;
  tooltipContent?: string;
  shouldShowDowngradeWarning?: boolean;
}

export function ProductButton({
  text,
  onClick,
  size = 'medium',
  fullColor,
  disabled,
  dataHook,
  fullWidth = true,
  tooltipContent,
  shouldShowDowngradeWarning,
}: ProductButtonProps) {
  const { t } = useTranslation();
  const buttonPriority = disabled ? 'secondary' : undefined;
  const buttonColorsClassName = fullColor
    ? s.cardsButton
    : s.cardsButtonSecondary;

  return (
    <Box direction='vertical' width='100%'>
      <Tooltip
        placement='bottom'
        content={
          tooltipContent ||
          t('Advanced.Plans_second.upgrade_plan.disabled.tooltip', 'Disabled')
        }
        className={s.cardsButtonTooltip}
        disabled={!disabled}
      >
        <Button
          className={classNames({
            [buttonColorsClassName]: !disabled,
            [s.minimized]: size === 'small',
          })}
          fullWidth={fullWidth}
          onClick={onClick}
          priority={buttonPriority}
          disabled={disabled}
          dataHook={dataHook}
          size={size}
        >
          {text}
        </Button>
      </Tooltip>
      {shouldShowDowngradeWarning && <DowngradeWarning />}
    </Box>
  );
}
